import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcLinkApi = async (
    gameSvcCd:string|null,
) => {
    return await CommApiInstance.post(`memb/game/${gameSvcCd}/link`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data.apiBody);
}
export default GameSvcLinkApi;